import ConfirmAction from './lib/ConfirmAction';
export default ConfirmAction;
